import { render, staticRenderFns } from "./login-password.vue?vue&type=template&id=1d99719c&scoped=true"
import script from "./login-password.vue?vue&type=script&lang=js"
export * from "./login-password.vue?vue&type=script&lang=js"
import style0 from "./login-password.vue?vue&type=style&index=0&id=1d99719c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99719c",
  null
  
)

export default component.exports